import { bindActionCreators } from 'redux';
import { useDispatch } from 'react-redux';
import { useMemo } from 'react';

const useActions = (actions, deps) => {
    const dispatch = useDispatch();
    return useMemo(() => {
        if (Array.isArray(actions)) {
            return actions.map((a) => bindActionCreators(a, dispatch));
        }
        return bindActionCreators(actions, dispatch);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, ...(deps || [])]);
};

export { useActions };
